/** Domains used when dispatching normalized cable events (extend as channels are added). */
export const REALTIME_DOMAINS = {
  SYSTEM: 'system',
  WILDCARD: '*',
};

export const WS_TICKET_PATH = '/ws-ticket/';
